import { useEffect } from "react";
import { FolderSidebar } from "@/features/chatplus/components/FolderSidebar";
import { ConversationList } from "@/features/chatplus/components/ConversationList";
import { ChatArea } from "@/features/chatplus/components/ChatArea";
import { DocumentPanel } from "@/features/chatplus/components/DocumentPanel";
import { useChatPlusStore } from "@/features/chatplus/store/chatPlusStore";
import * as api from "@/features/chatplus/services/api";
import { toast } from "sonner";

export default function ChatPlus() {
  const { setFolders, setIsLoading } = useChatPlusStore();

  useEffect(() => {
    loadFolders();
  }, []);

  const loadFolders = async () => {
    try {
      setIsLoading(true);
      const data = await api.fetchFolders();
      setFolders(data);
    } catch (error) {
      console.error("Erro ao carregar pastas:", error);
      toast.error("Erro ao carregar pastas");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex h-full min-h-0 w-full bg-background">
      {/* Painel Esquerdo: Pastas */}
      <div className="w-64 shrink-0">
        <FolderSidebar />
      </div>

      {/* Painel Esquerdo 2: Conversas */}
      <div className="w-64 shrink-0">
        <ConversationList />
      </div>

      {/* Centro: Chat */}
      <div className="flex-1 min-w-0">
        <ChatArea />
      </div>

      {/* Painel Direito: Documentos */}
      <div className="w-80 shrink-0">
        <DocumentPanel />
      </div>
    </div>
  );
}
